/** Admin UI copy — internal term: מופע (instance = one date+location slot). */

export const ADMIN_GROUP_INSTANCES_TAB = "מופעים";

export const ADMIN_GROUP_INSTANCES_IN_GROUP = (count: number) =>
  `${count} מופעים בקבוצה`;

export const ADMIN_GROUP_INSTANCES_HEADER = (count: number) =>
  `מופעים (${count})`;

export const ADMIN_GROUP_ADD_INSTANCE = "הוסף מופע";

export const ADMIN_GROUP_ADD_INSTANCE_TITLE = "הוספת מופע";

export const ADMIN_GROUP_NEW_INSTANCE_FOR = (title: string) =>
  `מופע חדש עבור "${title}"`;

export const ADMIN_GROUP_SAVE_INSTANCE = "שמור מופע";

export const ADMIN_GROUP_INSTANCES_LOAD_ERROR = "לא הצלחנו לטעון את המופעים";

export const ADMIN_GROUP_INSTANCES_EMPTY =
  "עדיין אין מופעים. הוסף מופע כדי שההתנדבות תופיע בפיד המתנדבים.";

export const ADMIN_GROUP_ADD_INSTANCE_ERROR = "קרתה תקלה בעת הוספת המופע";

export const ADMIN_GROUP_TOGGLE_LABEL =
  "קבוצת מופעים (כרטיס אחד בפיד)";

export const ADMIN_GROUP_CANNOT_DISABLE =
  "לא ניתן לבטל מצב קבוצה כל עוד קיימים מופעים";

export const ADMIN_GROUP_DETAILS_SECTION_TITLE = "מופעים";

export const ADMIN_GROUP_DETAILS_SECTION_HINT =
  "לאחר השמירה הוסיפו מופעים מעמוד המשימה.";

export const ADMIN_GROUP_DEFAULT_AMOUNT = "כמות משתתפים (ברירת מחדל למופעים)";

export const ADMIN_GROUP_CLOSE_ALL = "האם לסגור את כל המופעים בקבוצה?";

export const ADMIN_GROUP_CLOSE_ALL_HINT =
  "הפעולה תסמן כסגורים את כל המופעים בקבוצה.";

export const ADMIN_GROUP_CLOSED_ALL = "כל המופעים בקבוצה סגורים";

export const ADMIN_GROUP_REOPEN_ALL = "האם לפתוח מחדש את כל המופעים בקבוצה?";

export const ADMIN_GROUP_REOPENED_ALL = "כל המופעים בקבוצה פתוחים להרשמה";

export const ADMIN_GROUP_DELETE_ARCHIVE =
  "מחיקת הקבוצה תעביר לארכיון גם את כל המופעים שלה. להמשיך?";

export const ADMIN_GROUP_DELETE_HINT =
  "קבוצה שנדחתה לא חוסמת ארכיון. רק מתנדבים מאושרים או ממתינים לאישור חוסמים.";

export const ADMIN_GROUP_DELETE_BLOCKED =
  "לא ניתן למחוק אם יש מופעים עם מתנדבים מאושרים או ממתינים לאישור.";

export const ADMIN_GROUP_CANNOT_DELETE_WITH_PARTICIPANTS =
  "לא ניתן למחוק קבוצה שיש לה מופעים עם מתנדבים מאושרים או ממתינים לאישור";

export function adminCannotArchiveWithParticipantsMessage(
  approved: number,
  pending: number,
  isGroupParent = false,
): string {
  const where = isGroupParent ? "במופעים" : "במשימה";
  const parts: string[] = [];
  if (approved > 0) {
    parts.push(
      approved === 1 ? "מתנדב מאושר אחד" : `${approved} מתנדבים מאושרים`,
    );
  }
  if (pending > 0) {
    parts.push(
      pending === 1
        ? "בקשה אחת ממתינה לאישור"
        : `${pending} בקשות ממתינות לאישור`,
    );
  }
  if (parts.length === 0) {
    return isGroupParent
      ? ADMIN_GROUP_CANNOT_DELETE_WITH_PARTICIPANTS
      : "לא ניתן למחוק משימה שיש לה מתנדבים מאושרים או ממתינים לאישור";
  }
  return `לא ניתן למחוק: יש ${parts.join(" ו-")} ${where}. דחויים לא חוסמים - הסר או דחה את הנותרים קודם.`;
}

export const ADMIN_GROUP_ARCHIVED_SUCCESS =
  "הקבוצה וכל המופעים הועברו לארכיון בהצלחה";

export const ADMIN_GROUP_RESTORED_SUCCESS =
  "הקבוצה וכל המופעים שוחזרו מהארכיון בהצלחה";

export const ADMIN_GROUP_RESTORE_ARCHIVE =
  "שחזור הקבוצה יחזיר גם את כל המופעים שלה מהארכיון. להמשיך?";

export const ADMIN_GROUP_CREATE_INSTANCE_ERROR = "קרתה תקלה ביצירת המופע";

export const ADMIN_GROUP_CREATE_INSTANCE_SUCCESS = "המופע נוסף בהצלחה";

export const ADMIN_GROUP_LOCATION_PER_INSTANCE =
  "מיקום ההתנדבות ייקבע בכל מופע בנפרד.";

export const ADMIN_GROUP_ADD_ONE_FOR_FEED =
  "הוסיפו לפחות מופע אחד כדי שההתנדבות תופיע בפיד.";

export const ADMIN_TABLE_BADGE_GROUP_PARENT = "קבוצת מופעים";

export const ADMIN_TABLE_BADGE_GROUP_INSTANCE = "מופע";

export const ADMIN_GROUP_INSTANCE_BREADCRUMB_PARENT = "קבוצה";

export const ADMIN_TABLE_PARTNER_VIA_PARENT =
  "שיוך ארגון שותף מתבצע דרך משימת העל";

export const ADMIN_TABLE_SHOW_INSTANCES_SEPARATELY = "הצג מופעים בנפרד";

export const ADMIN_GROUP_BULK_GENERATE = "יצירה אוטומטית";

export const ADMIN_GROUP_BULK_GENERATE_TITLE = "יצירת מופעים אוטומטית";

export const ADMIN_GROUP_BULK_GENERATE_HINT =
  "בחרו ימים בשבוע, שעות וטווח - המערכת תייצר את כל המופעים בקבוצה.";

export const ADMIN_GROUP_BULK_MODE_BY_DAYS = "לפי ימים";

export const ADMIN_GROUP_BULK_MODE_BY_LOCATIONS = "לפי מיקומים";

export const ADMIN_GROUP_BULK_LOCATIONS_HINT =
  "הוסיפו מספר מיקומים עם אותו זמן - המערכת תייצר מופע לכל מיקום.";

export const ADMIN_GROUP_BULK_ADD_LOCATION = "הוסף מיקום";

export const ADMIN_GROUP_BULK_LOCATION_ROW = (index: number) =>
  `מיקום ${index}`;

export const ADMIN_GROUP_BULK_PREVIEW = "תצוגה מקדימה";

export const ADMIN_GROUP_BULK_CREATE = (count: number) =>
  `צור ${count} מופעים`;

export const ADMIN_GROUP_BULK_PREVIEW_SUMMARY = (
  toCreate: number,
  toSkip: number,
) =>
  toSkip > 0
    ? `ייווצרו ${toCreate} מופעים, ${toSkip} יידלגו (כבר קיימים)`
    : `ייווצרו ${toCreate} מופעים`;

export const ADMIN_GROUP_BULK_WARN_MANY = (count: number) =>
  `שימו לב: ייווצרו ${count} מופעים. ודאו שהפרטים נכונים לפני האישור.`;

export const ADMIN_GROUP_BULK_STATUS_NEW = "חדש";

export const ADMIN_GROUP_BULK_STATUS_SKIP = "יידלג";

export const ADMIN_GROUP_BULK_STATUS_PAST = "בעבר";

export const ADMIN_GROUP_BULK_RANGE_UNTIL_DATE = "עד תאריך";

export const ADMIN_GROUP_BULK_RANGE_WEEKS = "למשך שבועות";

export const ADMIN_GROUP_BULK_DAYS_LABEL = "ימים בשבוע";

export const ADMIN_GROUP_BULK_START_DATE = "תאריך התחלה";

export const ADMIN_GROUP_BULK_WEEK_COUNT = "מספר שבועות";

export const ADMIN_GROUP_BULK_END_DATE = "תאריך סיום";

export const ADMIN_GROUP_BULK_ERROR = "קרתה תקלה ביצירת המופעים";

export const ADMIN_GROUP_BULK_EDIT = (count: number) =>
  `עריכת נבחרים (${count})`;

export const ADMIN_GROUP_BULK_EDIT_TITLE = "עריכת מופעים";

export const ADMIN_GROUP_BULK_EDIT_HINT =
  "שדה שלא מסומן נשאר כמו שהוא בכל מופע. זמן, מיקום ומועד אחרון להרשמה משתנים רק אחרי תצוגה מקדימה.";

export const ADMIN_GROUP_BULK_EDIT_CONTENT_TITLE = "תוכן";

export const ADMIN_GROUP_BULK_EDIT_CRITICAL_TITLE =
  "קריטי: זמן, מיקום ומועד אחרון להרשמה";

export const ADMIN_GROUP_BULK_EDIT_PREVIEW = "תצוגה מקדימה";

export const ADMIN_GROUP_BULK_EDIT_CONFIRM = "אישור ושמירה";

export const ADMIN_GROUP_BULK_EDIT_BACK = "חזרה לעריכה";

export const ADMIN_GROUP_BULK_EDIT_UNCHANGED = "לא ישתנה";

export const ADMIN_GROUP_BULK_EDIT_APPLIES_TO = (count: number) =>
  `יחול על כל ${count} המופעים`;

export const ADMIN_GROUP_BULK_EDIT_NOTHING = "יש לסמן לפחות שדה אחד לעדכון";

export const ADMIN_GROUP_BULK_EDIT_SCHEDULE_UNCHANGED = "המועד לא ישתנה";

export const ADMIN_GROUP_BULK_EDIT_LOCATION_UNCHANGED = "המיקום לא ישתנה";

export const ADMIN_GROUP_BULK_EDIT_LAST_CALL_UNCHANGED =
  "המועד האחרון להרשמה לא ישתנה";

export const ADMIN_GROUP_BULK_EDIT_APPLY_SCHEDULE =
  "החל את אותו מועד על כל המופעים";

export const ADMIN_GROUP_BULK_EDIT_APPLY_LOCATION = "עדכן מיקום";

export const ADMIN_GROUP_BULK_EDIT_APPLY_LAST_CALL = "עדכן מועד אחרון להרשמה";

export const ADMIN_GROUP_BULK_EDIT_TIME_WARNING =
  "התאריך והשעה שנבחרו יוחלו זהים על כל המופעים הנבחרים. המועד האחרון להרשמה לא ישתנה, אלא אם תסמנו לעדכן אותו.";

export const ADMIN_GROUP_BULK_EDIT_MAX = (max: number) =>
  `ניתן לערוך עד ${max} מופעים בפעולה אחת`;

export const ADMIN_GROUP_BULK_EDIT_SAVE = (count: number) =>
  `שמירה ל-${count} מופעים`;

export const ADMIN_GROUP_BULK_EDIT_ERROR = "קרתה תקלה בעת עדכון המופעים";

export const ADMIN_TASK_BULK_EDIT_TITLE = "עריכת משימות";

export const ADMIN_TASK_BULK_EDIT_HINT =
  "שדה שלא מסומן נשאר כמו שהוא בכל משימה. זמן, מיקום ומועד אחרון להרשמה משתנים רק אחרי תצוגה מקדימה.";

export const ADMIN_TASK_BULK_EDIT_APPLIES_TO = (count: number) =>
  `יחול על כל ${count} המשימות`;

export const ADMIN_TASK_BULK_EDIT_MAX = (max: number) =>
  `ניתן לערוך עד ${max} משימות בפעולה אחת`;

export const ADMIN_TASK_BULK_EDIT_ERROR = "קרתה תקלה בעת עדכון המשימות";

export const ADMIN_BULK_EDIT_SENSITIVE_TITLE = "פעולה רגישה";

export const ADMIN_BULK_EDIT_SENSITIVE_HINT =
  "השיוכים הקיימים יוחלפו או יימחקו. שדה שלא מסומן לא משתנה.";

export const ADMIN_INSTANCE_STATUS_OPEN = "פתוח";
export const ADMIN_INSTANCE_STATUS_FULL = "מלא";
export const ADMIN_INSTANCE_STATUS_UNTREATED = "לא טופל";
export const ADMIN_INSTANCE_STATUS_CLOSED = "סגור";

export const ADMIN_INSTANCE_WARNING_NO_COORDINATES = "אין קואורדינטות";
export const ADMIN_INSTANCE_WARNING_LAST_CALL_SOON =
  "מועד אחרון להרשמה מתקרב (ביממה הקרובה)";
export const ADMIN_INSTANCE_WARNING_LAST_CALL_PAST =
  "מועד אחרון להרשמה עבר";
